import { render, staticRenderFns } from "./VisualizarDadosModal.vue?vue&type=template&id=b81d26ca&scoped=true"
import script from "./VisualizarDadosModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarDadosModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarDadosModal.vue?vue&type=style&index=0&id=b81d26ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81d26ca",
  null
  
)

export default component.exports